import http from '../http.js'
import {
  VOICE_CLONE_AGE_OPTIONS,
  VOICE_CLONE_GENDER_OPTIONS,
  VOICE_CLONE_LANGUAGE_OPTIONS,
  buildVoiceCloneCreateTaskRequestPayload,
  buildVoiceCloneNoiseReductionPayload,
} from '~/constants/aiVoiceCloning.js'

function optionLabel(options, value) {
  const text = String(value || '').trim()
  if (!text) return ''
  const matched = options.find((option) => {
    const optionValue = String(option.value || '').trim().toLowerCase()
    const optionLabelText = String(option.label || '').trim().toLowerCase()
    return optionValue === text.toLowerCase() || optionLabelText === text.toLowerCase()
  })
  return matched?.label || text
}

export const AiVoiceCloningApi = {
  CREATE_PREVIEW_TASK: '/api/aigc/audio/v1/audio-generation/create-task',
  CREATE_NOISE_REDUCTION_TASK: '/api/aigc/audio/audio-generation/create-task',
  GET_TASK_RESULT: '/api/aigc/audio/audio-generation/get-task-result',
  SAVE_USER_VOICE: '/api/aigc/audio/user-voice/save',
  GET_USER_VOICE_LIST: '/api/aigc/audio/user-voice/list',
  DELETE_USER_VOICE: '/api/aigc/audio/user-voice/delete',
  GET_HISTORY: '/api/aigc/audio/audio-generation/get-voice-history',
  DELETE_TASK: '/api/aigc/audio/audio-generation/delete-task',
  RENAME_VOICE: '/api/aigc/audio/voice-cloning/rename-voice',
}

export function createVoiceClonePreviewTask(data) {
  return http.post(
    AiVoiceCloningApi.CREATE_PREVIEW_TASK,
    buildVoiceCloneCreateTaskRequestPayload(data),
  )
}

export function createVoiceCloneNoiseReductionTask(data) {
  return http.post(
    AiVoiceCloningApi.CREATE_NOISE_REDUCTION_TASK,
    buildVoiceCloneNoiseReductionPayload(data),
  )
}

/** @param {{ task_id: string }} params */
export const getVoiceCloneTaskResult = (params) =>
  http.get(AiVoiceCloningApi.GET_TASK_RESULT, params)

export function saveClonedVoice(data = {}) {
  return http.post(AiVoiceCloningApi.SAVE_USER_VOICE, {
    voice_id: data.voice_id,
    name: data.name || data.voice_name || '',
    language: optionLabel(VOICE_CLONE_LANGUAGE_OPTIONS, data.language),
    gender: optionLabel(VOICE_CLONE_GENDER_OPTIONS, data.gender),
    age: optionLabel(VOICE_CLONE_AGE_OPTIONS, data.age),
    description: data.description || '',
  })
}

export function getUserVoiceList(params = {}) {
  return http.get(AiVoiceCloningApi.GET_USER_VOICE_LIST, {
    page: Number(params.page) || 1,
    size: Number(params.size) || 20,
  })
}

export function normalizeUserVoiceListRows(data) {
  if (Array.isArray(data)) return data
  const source = data?.result ?? data?.list ?? data?.records ?? data?.items ?? data?.data
  if (Array.isArray(source)) return source
  if (source && typeof source === 'object') {
    const nested = source.result ?? source.list ?? source.records ?? source.items
    if (Array.isArray(nested)) return nested
  }
  return []
}

/** @param {{ voice_ids?: Array<string | number> }} data */
export function deleteUserVoice(data = {}) {
  return http.post(AiVoiceCloningApi.DELETE_USER_VOICE, {
    voice_ids: Array.isArray(data.voice_ids) ? data.voice_ids : [],
  })
}

export function getClonedVoiceHistory(params = {}) {
  const query = {
    page: Number(params.page) || 1,
    size: Number(params.size) || 20,
  }
  if (params.task_type) query.task_type = params.task_type
  return http.get(AiVoiceCloningApi.GET_HISTORY, query)
}

/** @param {{ voice_ids?: string[], task_ids?: string[] }} data */
export function deleteClonedVoice(data = {}) {
  let taskIds = []
  if (Array.isArray(data.task_ids)) {
    taskIds = data.task_ids
  } else if (Array.isArray(data.voice_ids)) {
    taskIds = data.voice_ids
  }
  return http.post(AiVoiceCloningApi.DELETE_TASK, { task_ids: taskIds })
}

export function renameClonedVoice(data = {}) {
  return http.post(AiVoiceCloningApi.RENAME_VOICE, data)
}

